import React from 'react'

import { SearchIcon } from '@chakra-ui/icons'
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/input'
import { Box, Flex } from '@chakra-ui/layout'

import { Autocomplete as GoogleMapAutoComplete } from '@react-google-maps/api'

import { useGeoLocation } from '../../../../hooks/useGeoLocation'
import { useParking } from '../../../../hooks/useParking'

export function AutoComplete() {
  const { setLocation, setUserLocation } = useGeoLocation()
  const { refetch } = useParking()

  const ref = React.useRef<GoogleMapAutoComplete | null>(null)

  async function onPlaceChanged() {
    const place = ref.current?.state.autocomplete?.getPlace()

    const coords = place?.geometry?.location?.toJSON()

    setUserLocation(coords)
    setLocation(coords)
    setTimeout(async () => await refetch(), 500)
  }

  return (
    <Box
      boxSizing="border-box"
      minWidth="0px"
      minHeight="0px"
      gridColumnEnd={{
        base: 'span 12',
        notebook: 'span 6',
        computer: 'span 4',
      }}
    >
      <Flex
        height={{ base: 'auto', notebook: '100%' }}
        marginTop={{
          notebook: '0px',
        }}
        alignItems="center"
      >
        <Flex position="relative" width="100%">
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              children={
                <SearchIcon
                  width="16px"
                  height="16px"
                  color="rgb(152, 152, 166)"
                />
              }
            />
            <Box width="100%">
              <GoogleMapAutoComplete
                ref={ref}
                onPlaceChanged={onPlaceChanged}
                restrictions={{
                  country: 'BR',
                }}
              >
                <Input
                  placeholder="Informe cidade, endereço ou CEP"
                  width="100%"
                  outline="none"
                  transition="all 0.2s ease 0s"
                  borderRadius="9999px"
                  padding="12px 40px"
                  fontSize="12px"
                  lineHeight="16px"
                  color="rgb(35, 27, 34)"
                  backgroundColor="rgb(255, 255, 255)"
                  border="1px solid rgb(215, 215, 224)"
                  focusBorderColor="rgb(215, 215, 224)"
                  _focus={{
                    boxShadow:
                      'rgb(152 152 166 / 20%) 0px 5px 5px -3px, rgb(152 152 166 / 14%) 0px 8px 10px 1px, rgb(152 152 166 / 12%) 0px 3px 14px 2px',
                  }}
                  _hover={{
                    boxShadow:
                      'rgb(152 152 166 / 20%) 0px 2px 4px -1px, rgb(152 152 166 / 14%) 0px 4px 5px 0px, rgb(152 152 166 / 12%) 0px 1px 10px 0px',
                  }}
                />
              </GoogleMapAutoComplete>
            </Box>
          </InputGroup>
        </Flex>
      </Flex>
    </Box>
  )
}
